import * as React from 'react';
import { useSelector } from 'react-redux';
import { HeartFavouriteButton } from 'shared/components/HeartFavouriteButton';
import { NewbuildingHeaderServices } from 'shared/components/NewbuildingHeaderServices';
import { getBuilderChatEnabled, getNewbuildingComparisonStatus } from 'shared/selectors/newbuildingHeader';
import { useApplicationContext } from 'shared/utils/applicationContext';

import { NewbuildingFlatTourBookingContainer } from '../NewbuildingFlatTourBooking';
import { NewbuildingHeaderCallContainer } from '../NewbuildingHeaderCall';
import { NewbuildingHeaderChatButtonContainer } from '../NewbuildingHeaderChatButton';
import { NewbuildingHeaderCompareButton } from '../NewbuildingHeaderCompareButton';
import { COMPARE_ENABLED_CONFIG } from '../NewbuildingHeaderCompareButton/constants';
import { NewbuildingHeaderFavouriteButtonContainer } from '../NewbuildingHeaderFavouriteButton';
import { EComparisonStatus } from 'shared/types/newbuildingHeader';

/**
 * Если в ЖК есть и чаты и запись на просмотр – здесь размещаем чаты (записи на просмотр тут не будет)
 * если запись на просмотр есть, а чатов нет – тогда кнопка появляется
 * то есть, максимальное количество кнопок в обложке – 4 (2 с текстом + 2 только с иконками)
 */
export const NewbuildingHeaderServicesContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const isBuilderChatEnabled = useSelector(getBuilderChatEnabled);
  const isCompareEnabled = config.get<boolean>(COMPARE_ENABLED_CONFIG) || false;
  const comparisonStatus = useSelector(getNewbuildingComparisonStatus);

  const isCompareButtonVisible =
    isCompareEnabled && comparisonStatus && comparisonStatus !== EComparisonStatus.Unavailable;
  const isFlatTourBookingVisible = (isBuilderChatEnabled && !isCompareButtonVisible) || !isBuilderChatEnabled;

  return (
    <NewbuildingHeaderServices>
      <NewbuildingHeaderCallContainer />
      {isBuilderChatEnabled && <NewbuildingHeaderChatButtonContainer />}
      {isFlatTourBookingVisible && (
        <NewbuildingFlatTourBookingContainer isShortened={isBuilderChatEnabled && !isCompareEnabled} />
      )}
      <NewbuildingHeaderCompareButton withOnboarding={true} />
      <NewbuildingHeaderFavouriteButtonContainer button={HeartFavouriteButton} />
    </NewbuildingHeaderServices>
  );
};
